import React, { useEffect, useState } from "react";
import client from "../../../services/Client";
import { useUserContext } from "../../../components/context/UserContext";
import noData from "../../../assets/Images/NoData.svg";
import { toast } from "react-toastify";
import CustomModal from "../../../shared/CustomModal";
import { useNavigate } from "react-router-dom";

function CustomerPlots({ locationId, siteName, category, fetchPlotsData }) {
  const { state } = useUserContext();
  const [plots, setPlots] = useState([]);
  const navigate = useNavigate();
  const [plotToDelete, setPlotToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setShowOverlay(false);
  };

  const fetchPlots = async (locationId) => {
    // setIsLoading(true);
    try {
      const response = await client.get(
        `admin/get-all-plots?locationId=${locationId}&soldPlotsFor=customer`,
        {
          params: {
            category: category,
            siteName: siteName,
          },
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        }
      );

      const allPlots = response?.data?.data[0]?.plots || [];
      setPlots(allPlots);
    } catch (error) {
      console.error("Error fetching plots:", error);
    } finally {
    }
  };
  useEffect(() => {
    fetchPlots(locationId);
  }, [locationId, category, siteName, plots]);

  const handleMakeAvailable = (plotId) => {
    const plot = plots?.find((plot) => plot.id === plotId);
    setPlotToDelete(plot);
    setShowDeleteModal(true);
    setShowOverlay(true);
  };

  const confirmAvailable = async (plotId) => {
    try {
      setIsLoading(true);
      await client.put(`customer/make-plot-available/${plotId}`, null, {
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setPlots((prevPlots) =>
        prevPlots?.map((plot) =>
          plot.id === plotId ? { ...plot, isAvailable: true } : plot
        )
      );
      setShowDeleteModal(false);
      setShowOverlay(false);
      setIsLoading(false);
      navigate("/plotsManagement");
      fetchPlots(locationId);
      fetchPlotsData(locationId);
      toast.success("Plots are now available");
    } catch (error) {
      console.error("Error making available plots:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {showOverlay && <div className="overlay"></div>}
      <table border="0" cellpadding="0" style={{ width: "100%" }}>
        <thead
          style={{
            backgroundColor: "#FDFDFD",
            border: "1px solid #EDEDED",
          }}
        >
          <tr>
            <th style={{ padding: "22px 15px 22px 30px" }}>Site Name</th>
            <th>Category</th>
            <th>Plot Number</th>
            <th>Size (m2)</th>
            <th>Price</th>
            <th className="text-center">Select</th>
          </tr>
        </thead>
        <tbody>
          {plots?.map((filteredPlot, index) => (
            <tr key={index}>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td
                        className="product-img"
                        style={{
                          border: "none",
                          padding: "10px 10px 10px 25px",
                        }}
                      >
                        {filteredPlot.plots[0].images &&
                        filteredPlot.plots[0].images[0] ? (
                          <img
                            style={{
                              width: "50px",
                              height: "50px",
                            }}
                            src={filteredPlot.plots[0].images[0]}
                            alt="location"
                          />
                        ) : (
                          <span>No Image Available</span>
                        )}
                      </td>
                      <td className="rating" style={{ border: "none" }}>
                        {filteredPlot.siteName}
                        <p>{filteredPlot.plotCode}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>{filteredPlot.category}</td>
              <td>
                {filteredPlot.plots
                  .map((singlePlot) => singlePlot.plotNumber)
                  .join(", ")}
              </td>
              <td>{filteredPlot.totalPlotSize}</td>
              <td>{`£${filteredPlot.totalPrice}`}</td>
              <td
                style={{
                  padding: "0 30px",
                  accentColor: "#219653",
                  textAlign: "center",
                }}
              >
                <button
                  onClick={() => handleMakeAvailable(filteredPlot?.id)}
                  className="break_plot"
                  style={{ width: "120px", background: "#219653" }}
                >
                  Make Available
                </button>
              </td>
            </tr>
          ))}
          {plots?.length === 0 && (
            <tr>
              <td colSpan="6" className="text-center no_data-image-one">
                <img src={noData} alt="No Data" width={"100%"} height="100%" />
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <CustomModal
        isOpen={showDeleteModal}
        onClose={cancelDelete}
        isLoading={isLoading}
        SuccessMessage="Please confirm!"
        ModalMessage="Are you sure you want to make available this plot?"
        onConfirmDelete={() => confirmAvailable(plotToDelete?.id)}
      />
    </div>
  );
}

export default CustomerPlots;
